interface TeamStatsCardProps {
  totalMembers: number
  isLoading: boolean
  onInvite: () => void
}

export function TeamStatsCard({
  totalMembers,
  isLoading,
  onInvite,
}: TeamStatsCardProps) {
  return (
    <div className='mt-[24px] flex w-full justify-center px-[20px]'>
      <div className='relative h-[134px] w-full overflow-hidden rounded-[28px] bg-[#6e59cd] shadow-[0px_10px_20px_rgba(110,89,205,0.25)]'>
        <div className='absolute -right-[20px] -top-[20px] h-[150px] w-[150px] rounded-full bg-white opacity-5'></div>
        <div className='absolute bottom-[10px] left-[40px] h-[80px] w-[80px] rounded-full bg-white opacity-5'></div>

        <div className='absolute left-[24px] top-[24px]'>
          <p className='font-normal text-[14px] leading-normal text-white/80 not-italic'>
            Total Team Members
          </p>
          <div className='mt-[4px] flex items-center gap-[8px]'>
            <div className='flex h-[28px] w-[28px] items-center justify-center'>
              <svg
                width='28'
                height='28'
                viewBox='0 0 24 24'
                fill='none'
                xmlns='http://www.w3.org/2000/svg'
              >
                <path
                  d='M16 11C18.2091 11 20 9.20914 20 7C20 4.79086 18.2091 3 16 3C13.7909 3 12 4.79086 12 7C12 9.20914 13.7909 11 16 11ZM8 13C10.2091 13 12 11.2091 12 9C12 6.79086 10.2091 5 8 5C5.79086 5 4 6.79086 4 9C4 11.2091 5.79086 13 8 13ZM8 15C5.33333 15 0 16.3333 0 19V21H16V19C16 16.3333 10.6667 15 8 15ZM16 13C15.6845 13 15.3776 13.0248 15.0827 13.0718C16.5746 13.91 17.5855 15.3023 18.0673 17H24V15C24 13.3333 19.3333 13 16 13Z'
                  fill='white'
                />
              </svg>
            </div>
            <span
              className='font-black text-[32px] leading-normal text-white not-italic'
              data-testid='total-members-count'
            >
              {isLoading ? '...' : totalMembers}
            </span>
          </div>
        </div>

        <button
          onClick={onInvite}
          className='absolute right-[20px] top-[50%] flex h-[36px] min-w-[90px] -translate-y-1/2 transform items-center justify-center rounded-[18px] bg-[#46B778] px-[12px] text-[14px] font-bold text-white shadow-lg transition-transform active:scale-95'
          data-testid='invite-button'
        >
          Invite Users
        </button>
      </div>
    </div>
  )
}
